import { render } from "./AdvsDor.vue?vue&type=template&id=715ba6aa"
import script from "./AdvsDor.vue?vue&type=script&lang=js"
export * from "./AdvsDor.vue?vue&type=script&lang=js"

import "./AdvsDor.vue?vue&type=style&index=0&id=715ba6aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__